// The sign-in screen and the session states around it.
export const login = {
  // ── auth ─────────────────────────────────────────────────────────────
  'auth.checking': 'در حال بررسی نشست…',
  'auth.loading': 'در حال بارگذاری فضای کاری…',
  'auth.retry': 'شروع دوباره',
  'auth.loopError': 'ورود بارها تکرار شد و متوقف شد. نشست را پاک کنید و دوباره تلاش کنید.',
  'auth.loopTitle': 'ورود ناموفق بود',
  'auth.checkingHint': 'چند لحظه صبر کنید',
  'auth.stuck': 'هدایت نشدید؟',
  'auth.manualSignIn': 'اینجا کلیک کنید',
  // core.md §4.3: the boot's status query failing is «سرویس در دسترس نیست» —
  // an outage with a retry, never a verdict about the account.
  'auth.bootFailed.title': 'سرویس در دسترس نیست',
  'auth.bootFailed.body': 'سرور پاسخ نداد. مشکلی برای حساب شما پیش نیامده و بیماران شما دست‌نخورده‌اند.',
  'auth.session.expiringTitle': 'نشست شما در حال پایان است',
  'auth.session.expiringBody': 'برای ادامهٔ کار بدون وقفه، نشست را تمدید کنید. آنچه نوشته‌اید در هر صورت روی صفحه می‌ماند.',
  'auth.session.staySignedIn': 'ادامهٔ کار',
  'auth.session.expiredTitle': 'نشست شما به پایان رسید',
  'auth.session.expiredBody': 'برای ادامه دوباره وارد شوید. به همین صفحه برمی‌گردید.',
  'auth.session.signInAgain': 'ورود مجدد',
  'auth.session.returnNotice': 'آنچه ذخیره کرده‌اید محفوظ است. آنچه روی صفحه است و هنوز ذخیره نشده ممکن است از دست برود.',

  // ── login ────────────────────────────────────────────────────────────
  'login.title': 'پنل دانشجو و دستیار',
  'login.sub': 'بیمار بسازید، ویزیت را مستند کنید و از دستیار آموزشی «چرا» بپرسید.',
  'login.action': 'ورود یا ثبت‌نام با شمارهٔ موبایل',
  'login.working': 'در حال انتقال به صفحهٔ ورود…',
  'login.hint': 'ورود با شمارهٔ موبایل و کد یک‌بارمصرف انجام می‌شود.',
  'login.feature.case.title': 'بیمار تمرینی بسازید',
  'login.feature.case.body': 'فردی خیالی که خودتان می‌سازید. هرگز یک فرد واقعی.',
  'login.feature.visit.title': 'ویزیت را مستند کنید',
  'login.feature.visit.body': 'یادداشت SOAP، تشخیص‌ها، نسخه و دستورات — همان‌طور که یک پزشک می‌نویسد.',
  'login.feature.chat.title': 'با دستیار آموزشی گفتگو کنید',
  'login.feature.chat.body': 'کل پرونده را می‌شناسد و استدلالش را توضیح می‌دهد.',
  'login.free': 'هر ماه ۵۰۰ پارسه رایگان',
  'login.badRedirect': 'این نشانی برای ورود ثبت نشده است. پنل را از نشانی رسمی باز کنید.',
};

export default login;
